import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { imaginationFlowSegments } from "@/lib/data/imaginationFlow";
import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/imagination/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  beforeLoad: () => ({
    title: "imagination.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const search = useSearch({
    from: "/(content)/adults/exercises/(shared)/imagination/",
  });

  const currentSegment = imaginationFlowSegments[0];
  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Link
          to="/adults/exercises/imagination/exercise"
          search={{ referrer: search.referrer }}
        >
          <Button className="w-full">
            <FormattedMessage id="common.next" />
          </Button>
        </Link>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="imagination.intro" />
      </p>
      <MediaPlayer
        src={currentSegment.audio}
        segment={currentSegment.segment}
      />
    </ExerciseLayout>
  );
}
